import React from 'react';

import { StorageProvider } from './StorageContext';

export const PresetStorage = ({
  children,
  mapScreenStateToPreset,
  mapPresetToScreenState,
  preset,
  parent,
  onSave,
  title,
  id,
}) => {
  const state = React.useMemo(() => {
    return {
      presetId: id,
      title,
      ...mapPresetToScreenState(preset, parent),
      ready: true,
    };
  }, [preset, parent, id]);

  const handleSave = React.useCallback((data) => {
    return onSave(mapScreenStateToPreset(data));
  }, []);

  return (
    <StorageProvider state={state} onSave={handleSave}>
      {children}
    </StorageProvider>
  );
};
